export default __webpack_public_path__ + "static/media/Dreamcatcher_LE.ff99589a.jpg";